import { isProduction } from '@lib/utils';
import { call } from '@packages/functions';
import { Map } from 'immutable';

const DEFAULT_STATE = Map({});

export abstract class Reducer {
    static DEFAULT_STATE = {
        busy: false,
        error: null,
        items: [],
        item: null,
    };

    /**
     * @type {string}
     */
    public NAME = '';

    /**
     * @type {object}
     */
    public alias = {};

    private fetchAlias: any;

    protected abstract onDefault(state: any): any;

    /**
     *
     * @returns {Object}
     */
    public getAliases() {
        return this.alias;
    }

    /**
     *
     * @param alias
     */
    public setAlias(alias) {
        this.alias = alias;
    }

    /**
     *
     * @param type
     * @param property
     */
    public addAlias(type: string, property: string) {
        this.alias[type] = property;
    }

    /**
     *
     * @param type
     * @return {*}
     */
    public getMethod(type) {
        let rules = this.alias || {};

        // noinspection JSUnresolvedVariable
        if (this.fetchAlias && typeof this.fetchAlias === 'function') {
            // noinspection JSUnresolvedFunction
            const newRules = this.fetchAlias(rules);
            rules = {
                ...rules,
                ...(newRules || {}),
            };
        }

        const rule = rules.hasOwnProperty(type) ? rules[type] : null;

        if (rule && this[rule]) {
            return rule;
        }

        return null;
    }

    /**
     *
     * @param state
     * @param action
     * @return {*}
     */
    public reducer(state, action) {
        if (action && action.type) {
            const method = this.getMethod(action.type);
            if (method) {
                return this[method](state, action);
            }
        }

        return (state ? state : call(this.onDefault, DEFAULT_STATE)) ?? DEFAULT_STATE;
    }

    /**
     *
     * @param name
     * @private
     */
    __call(name) {
        if (!isProduction()) {
            console.error(`Undefined method '${name}';`);
        }
    }
}
